import { createRoute } from "./utils"

const adminRoutes = {
	// Users
	users: createRoute(`/admin/users`, null, true),
	user: createRoute(
		`/admin/users/:userId/edit`,
		(userId: string) => `/admin/users/${userId}/edit`,
		true,
	),

	// Orders
	orders: createRoute(`/admin/orders`, null, true),

	// Products
	products: createRoute(`/admin/products`, null, true),
	product: {
		edit: createRoute(
			`/admin/products/:productId/edit`,
			(productId: string) => `/admin/products/${productId}/edit`,
			true,
		),
		preview: createRoute(
			"/admin/products/:productId/preview",
			(productId: string) => `/admin/products/${productId}/preview`,
			true,
		),
		create: createRoute(`/admin/products/new`, null, true),
	},

	// Contacts
	contacts: createRoute(`/admin/contacts`, null, true),
	contact: createRoute(
		`/admin/contacts/:contactId`,
		(contactId: string) => `/admin/contacts/${contactId}`,
		true,
	),

	// Blog
	blog: {
		index: createRoute(`/admin/blog`, null, true),
		create: createRoute(`/admin/blog/new`, null, true),
		edit: createRoute(
			`/admin/blog/:postId/edit`,
			(postId: string) => `/admin/blog/${postId}/edit`,
			true,
		),
		preview: createRoute(
			`/admin/blog/:postId/preview`,
			(postId: string) => `/admin/blog/${postId}/preview`,
			true,
		),
	},
}

export default adminRoutes
